<style lang="scss" scoped>
    .box{
        display: inline-block;
        width: 100px;
        margin-right: 4px;
        text-align: center;
    }
    .demo-upload-list {
        width: 100%;
        height: 100px;
        line-height: 100px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    .mask-gray {
        position: absolute;
        left: 0px;
        top: 0px;
        background: rgba(204, 204, 204, 0.1);
        z-index: 2;
        cursor: not-allowed;
        bottom: 5px;
        width: 100px;
    }
    .txt{
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .checkImg{
        background: #2a303f !important;
        padding: 40px;
        text-align: center;
    }
    .checkImg img{
        width: auto !important;
        max-width: 100%;
    }
</style>
<template>
    <div class="positionRL">
        <div v-for="item in uploadList" class="box">
            <div class="demo-upload-list">
                <template>
                    <img :src="item.url">
                    <div class="demo-upload-list-cover">
                        <Icon type="ios-eye-outline" v-if="isMagnify"></Icon>
                        <Icon type="ios-trash-outline"></Icon>
                    </div>
                </template>
            </div>
            <p class="txt" v-if="txt">{{item.name}}</p>
        </div>
        <Upload v-show="uploadList.length < 1 || isMore"
                ref="upload"
                :show-upload-list="false"
                :default-file-list="list"
                type="drag"
                :format="['GIF','JPEG','JPG','PNG','SVG']"
                :action="uploadHost"
                :data='uploadData'
                :before-upload="handleBeforeUpload"
                :on-success="handleSuccess"
                style="display: inline-block;width:98px;">
            <div style="width: 98px;height:98px;">
                <Icon class="m-t-30" type="md-add" size="20"></Icon>
                <p class="center">上传图片</p>
            </div>
        </Upload>
        <span class="m-l-10" v-show="uploadList.length<1 || isMore">注:上传图片格式仅支持gif、jpeg、jpg、png、svg</span>
        <div v-if="disabled" class="mask-gray"></div>
        <Modal title="查看图片" v-model="visible">
            <div class="checkImg">
                <img :src="imgName" v-if="visible" style="width: 100%">
            </div>
        </Modal>
    </div>
</template>
<script>
    // import {oss} from '@/libs/uploadFile'
    // import axios from 'axios'
    export default {
        name: 'logo-upload',
        props: {
            list: {
                type: Array,
                default: []
            },
            disabled: {
                default: false
            },
            isMore: { //多张上传
                default: false
            },
            isMagnify:{ //查看大图
                default: false
            },
            delete: { //自定义删除
                default: false
            },
            txt: { //是否显示图片名称
                default: false
            },
            type: { //1、用户上传  2、菜单图标   3、logo
                default: 1   //默认是用户上传
            }
        },
        data() {
            return {
                uploadList: [],
                name: new Date().getTime(),
                imgName: '',
                visible: false,
                uploadHost: '',
                uploadData: {},
                fileName: '',
                filePath: ''
            };
        },
        watch: {
            list() {
                this.uploadList = JSON.parse(JSON.stringify(this.list));
            }
        },
        mounted() {
            this.uploadList = JSON.parse(JSON.stringify(this.list));
        },
        methods: {
            handleView (file) {
                this.imgName = file.url;
                this.visible = true;
            },
            handleRemove(file) {
                if(this.delete) { //调用自己页面的删除
                    this.$emit('handleRemove', file.id);
                }else{
                    this.$Modal.confirm({
                        title: '提示',
                        content: '确认删除文件或图片？',
                        onOk: () => {
                            if(file.url){
                                axios.delete(`/as/file?filePath=${file.url}`, {
                                }).then(res => {
                                    if (res.data.success) {
                                        const fileList = this.$refs.upload.fileList;
                                        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
                                        this.uploadList = this.$refs.upload.fileList;
                                        this.$emit('submit', '');
                                    }
                                })
                            }
                        }
                    });

                }
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: '格式错误',
                    desc: '上传图片格式仅支持.jpeg/jpg/png'
                });
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '文件过大',
                    desc: '上传LOGO支持最大256kb'
                });
            },
            handleBeforeUpload(file) {
                let extension = file.name.split('.').pop();//具体格式
                extension=extension.toUpperCase();
                var arr = ['GIF','JPEG','JPG','PNG','SVG'];
                if(arr.indexOf(extension)==-1){
                    this.$Message.error('文件格式错误，请重新上传')
                    return;
                }
                if(this.isMore){
                    return oss(file.name,this.type).then(res=> {
                        this.uploadHost = res.host
                        this.uploadData = res
                        this.filePath = res.host.concat("/",res.key);
                    })
                    return false;
                }
                const check = this.uploadList.length < 1;
                if (!check) {
                    this.$Notice.warning({
                        title: '仅能上传1张图片'
                    });
                } else {
                    return oss(file.name,this.type).then(res=> {
                        this.uploadHost = res.host
                        this.uploadData = res
                        this.filePath = res.host.concat("/",res.key);
                    })
                }
                return false;
            },
            // 上传成功的回调函数
            handleSuccess(res, file, fileList) {
                if(file.response.Status == 'OK'){
                    let arr = []
                    this.$refs.upload.fileList.forEach((num) => {
                        if(num.uid == file.uid){
                            num.url = this.filePath;
                        }
                        arr.push(num)
                    })
                    this.uploadList = arr;
                    this.submit();
                }
            },

            submit() {
                let arr = JSON.parse(JSON.stringify(this.$refs.upload.fileList));
                let str,strName;
                for(let i of arr){
                    str = i.url;
                    strName = i.name;
                }
                this.$emit('submit', str, strName);
            },
        },
        components: {}
    };
</script>


// WEBPACK FOOTER //
// src/components/logo-upload.vue